import VersionNoPage from "@/views/MGT/Version/Components/VersionNoPage";
import VersionPage from "@/views/MGT/Version/Components/VersionPage";
export default {
  name: "Version",
  components: {
    VersionNoPage,
    VersionPage
  },
  data() {
    return {
      pageBoo: false
    };
  },
  methods: {
    onChangeAll() {
      this.pageBoo = true;
    }
  }
};